import { Dispensary } from "@/custom-types/Dispensary";

const isDispensaryDeliveryOnly = (tags: Dispensary["tags"]) =>
  tags.includes("delivery") && !tags.includes("storefront");

export default isDispensaryDeliveryOnly;
